import React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export default function Lightbox({open, onClose, onPrevious, onNext, image, title}) {
    return (
        <Modal className={"lightbox-modal"} open={open} onClose={onClose}>
            <div className={"lightbox-modal-content"}>
                <div className="close-button" onClick={onClose}>
                    <CloseIcon />
                </div>

                <div className="image-container">
                    <img src={image} alt={title} />
                </div>

                <div className="image-title">
                    <strong>{title}</strong>
                </div>

                <div className="navigation-buttons">
                    <div className="nav-button prev" onClick={onPrevious}>
                        <NavigateBeforeIcon />
                    </div>
                    <div className="nav-button next" onClick={onNext}>
                        <NavigateNextIcon />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
